import { curry } from "ramda";

import addLeadingZero from "./addLeadingZero";

export default curry(function (format, x) {
  let d = new Date(x);
  let s = format;
  let formatter = {
    YYYY: function (date) {
      return date.getFullYear();
    },
    MM: function (date) {
      return addLeadingZero(formatter.M(date));
    },
    M: function (date) {
      return date.getMonth() + 1;
    },
    DD: function (date) {
      return addLeadingZero(formatter.D(date));
    },
    D: function (date) {
      return date.getDate();
    },
    HH: function (date) {
      return addLeadingZero(formatter.H(date));
    },
    H: function (date) {
      return date.getHours();
    },
    mm: function (date) {
      return addLeadingZero(formatter.m(date));
    },
    m: function (date) {
      return date.getMinutes();
    },
    SS: function (date) {
      return addLeadingZero(formatter.S(date));
    },
    S: function (date) {
      return date.getSeconds();
    },
  };

  Object.keys(formatter)
    .sort(function (a, b) {
      return b - a;
    })
    .forEach(function (token) {
      s = s.replace(new RegExp(token, "g"), formatter[token](d));
    });

  return s;
});
